import { render, staticRenderFns } from "./PublishUnitDialog.vue?vue&type=template&id=39860ec2&scoped=true&"
import script from "./PublishUnitDialog.vue?vue&type=script&lang=js&"
export * from "./PublishUnitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39860ec2",
  null
  
)

export default component.exports